{
    "punk": {
        "key": "punk",
        "isDead": false,
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "energy": {},
        "power": 10,
        "maxhealth": 30,
        "effects": {},
        "inventory": {
            "items": {}
        },
        "level": 3
    }
}